import Vue from 'vue';
if(document.getElementById('cycle-page')) {
    let lector = new Vue({
        el:'#cycle-page',
        data:{
            archive:{},
            schedule:{},
            load: false,
            cycle:{},
            page: 1,
            pageCount: 0
        },
        mounted:function () {
          this.fetchCycle();
          this.fetchSchedule();
          this.fetchArchive();

        },
        filters:{
            plural:function(number,titles){
                let cases = [2, 0, 1, 1, 1, 2];
                return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
            }
        },
        
        methods:{
            fetchCycle: function () {
                var self = this;

                this.load = true;

                try {
                    $.ajax({
                        url: '/api/v1/cycle/view',
                        dataType: "json",
                        data: {id:cycleId},
                        success: function (data) {
                            self.cycle = data.item;
                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            },
            classRating: function (rating) {

                return {
                    'best': (rating > 4 ),
                    'good': (rating > 3 && rating <= 4),
                    'normal': (rating > 2 && rating <= 3),
                    'poorly': (rating > 1 && rating <= 2),
                    'bad': rating <= 1
                };
            },
            fetchSchedule:function(){
                var self = this;

                $.ajax({
                    url: '/api/v1/lection',
                    dataType: "json",
                    data: {'schedule':1,cycle_id:cycleId},
                    success: function (data) {

                        self.schedule = data;
                    },
                    fail: function () {

                        throw new Error('Ошибка получении данных');

                    }
                });
            },
            fetchArchive:function(append){
                var self = this;
                this.load = true;

                try {

                    var data = {'schedule':0,cycle_id:cycleId};

                    $.extend(data, {page: this.page});

                    $.ajax({
                        url: '/api/v1/lection',
                        dataType: "json",
                        data: data,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {

                                    self.archive.items.push(item);

                                });

                            } else {

                                self.archive = data;
                                self.pageCount = data._meta.pageCount;
                                self.page = 1;

                            }
                            self.load = false;

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            }
        }
    });
}